export const DOG_BREEDS = [
  "Mixed Breed",
  "Labrador Retriever",
  "Golden Retriever",
  "German Shepherd",
  "French Bulldog",
  "Bulldog",
  "Poodle (Standard)",
  "Poodle (Miniature)",
  "Poodle (Toy)",
  "Beagle",
  "Rottweiler",
  "Dachshund",
  "Yorkshire Terrier",
  "Boxer",
  "Pembroke Welsh Corgi",
  "Australian Shepherd",
  "Cavalier King Charles Spaniel",
  "Shih Tzu",
  "Border Collie",
  "Cocker Spaniel",
  "Chihuahua",
  "Pomeranian",
  "Miniature Schnauzer",
  "Great Dane",
  "Doberman Pinscher",
  "Siberian Husky",
  "Bernese Mountain Dog",
  "Pug",
  "Maltese",
  "Jack Russell Terrier",
  "Staffordshire Bull Terrier",
  "Greyhound",
  "Whippet",
  "Saint Bernard",
];

export const CAT_BREEDS = [
  "Domestic Shorthair",
  "Domestic Longhair",
  "Maine Coon",
  "Persian",
  "Ragdoll",
  "British Shorthair",
  "Siamese",
  "Bengal",
  "Sphynx",
  "Scottish Fold",
  "Russian Blue",
  "Abyssinian",
  "Burmese",
  "Birman",
  "Norwegian Forest Cat",
  "Oriental Shorthair",
  "American Shorthair",
  "Devon Rex",
  "Exotic Shorthair",
  "Tonkinese",
];
